import { render, staticRenderFns } from "./LocalisationEvents.vue?vue&type=template&id=29a66a2b&"
import script from "./LocalisationEvents.vue?vue&type=script&lang=ts&"
export * from "./LocalisationEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports